(function (window, document, $) {

    $(document).ready(function () {
        // Animated slider =============================================================================================

        $('body').on('click', '[data-slide-to]', function (e) {
            e.preventDefault();

            var target = this.href.split('#')[1],
                $target = $('#' + target),
                slideEl = e.target.dataset.slider,
                $slideEl = $(slideEl),
                newTop = $target.position().top,
                newLeft = $target[0].offsetLeft - 24,
                duration = Math.abs(Math.pow(Math.abs($slideEl.offset().left - newLeft), 2 / 3) * 8);

            if (typeof slideEl === 'undefined') {
                slideEl = 'body, html';
            }

            if ($target.length > 0) {
                $slideEl.animate({ scrollTop: newTop, scrollLeft: newLeft }, duration, 'swing');
            }
        });


        // Slider navigation ===========================================================================================

        $('body').on('click', '.js-slider-navigation', function (e) {
            e.preventDefault();

            var $target = $(e.target),
                slideEl = $target.data('slider'),
                $slideEl = $(slideEl),
                scrollDirection = parseFloat($target.data('slide-direction')),
                sliderWidth = $(slideEl + ' .js-slider-item').outerWidth(true),
                amount = $target.data('slide-amount'),
                scrollAmount = scrollDirection * sliderWidth * amount,
                loadMore = $slideEl.data('load-more-slide'),
                totalScrollWidth = $slideEl[0].scrollWidth - $slideEl.width();

            $slideEl.animate({ scrollLeft: '+=' + scrollAmount }, '300', 'linear', function (e) {
                var $arrowLeft = $('.js-slider-navigation[data-slider="' + slideEl + '"][data-slide-direction="-1"]'),
                    $arrowRight = $('.js-slider-navigation[data-slider="' + slideEl + '"][data-slide-direction="1"]'),
                    percentageScroll = $slideEl.scrollLeft() / totalScrollWidth * 100;

                if (loadMore && percentageScroll >= 85) {

                    var data = {
                        action: 'get_posts',
                        template: 'video-block',
                        post_type: 'video',
                        offset: $slideEl.data('slider-offset'),
                        filter: 'id:int',
                        amount: 3
                    };

                    getData(data, $slideEl);
                }
            });
        });

        function getData(data, target) {

            $.ajax({
                type: 'POST',
                url: themevars.ajaxurl,
                data: data,
                dataType: 'json',

                complete: function (e) { },

                success: function (response) {

                    var sliderOffset = target.data('slider-offset'),
                        newSliderOffset = target.data('slider-offset', sliderOffset + response.posts.length);

                    for (var i in response.posts) {
                        var $wrapper = $('#slider-item-wrapper').clone();
                        $wrapper
                            .removeClass('d-none')
                            .empty()
                            .removeAttr('id')
                            .html($(response.posts[i].html))
                            .appendTo(target);
                    }

                    target.attr('data-slider-offset', target.data('slider-offset'));

                    if (response.posts.length < 3) {
                        var sliderLoadMoreFalse = target.data('load-more-slide', false),
                            $arrowRight = $('.js-slider-navigation[data-slider="' + target.data('slider') + '"][data-slide-direction="1"]');

                        target.attr('data-load-more-slide', target.data('load-more-slide'));
                    }

                },
                error: function (e) { }
            });

        }
    });

}(window, document, jQuery));
